export default __webpack_public_path__ + "resources/icons/d200-0f3f.webp";